<template>
  <div class="cateContent">
    <div class="left-aside" ref="left">
      <div
        v-for="(item,index) in flist"
        :key="item.id"
        class="f-item b-b flex-column"
        :class="{active: index*1 === currentIndex*1}"
        @click="clickLeft(index)"
      >{{item.alias?item.alias:item.name}}</div>
    </div>
    <div class="right-aside" ref="right">
      <div v-for="fitem in list" :key="fitem.id" class="s-list" :id="'main-'+fitem.id">
        <span class="f-item-label">{{fitem.name}}</span>
        <div class="t-list">
          <div
            v-for="sitem in fitem.children"
            :key="sitem.id"
            v-if="sitem.children.length===0"
            class="t-item"
            @click="navToList(fitem.id,sitem.id,0,sitem.name)"
          >
            <van-image lazy-load :src="sitem.picture" width="70" height="70" />
            <div class="d-inline-block text-truncate text-nowrap">{{sitem.name}}</div>
          </div>
        </div>
        <div v-for="sitem in fitem.children" class="t-list" :key="sitem.id">
          <div v-if="sitem.children.length>0" class="s-item">
            <div class="s-item-left"></div>
            <span class="s-item-text">{{sitem.name}}</span>
            <div class="s-item-right"></div>
          </div>
          <div
            class="t-item"
            v-if="sitem.children.length>0"
            v-for="titem in sitem.children"
            :key="titem.id"
            @click="navToList(fitem.id,sitem.id, titem.id,titem.name)"
          >
            <van-image lazy-load :src="titem.picture" width="70" height="70" />
            <div class="d-inline-block text-truncate text-nowrap">{{titem.name}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
  data () {
    return {
      sizeCalcState: false,
      tabScrollTop: 0,
      currentId: 1,
      list: [],
      flist: [],
      slist: [],
      tlist: [],
      changeSidebarTime: 0,
      currentIndex: 0,
      scrollY: 0,
      listHeight: []
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      this.getCategory()
    },
    scrollInit () {
      this.$refs.right.addEventListener('scroll', (res) => {
        let scrollTop = res.target.scrollTop
        this.scrollY = Math.abs(Math.round(scrollTop))
        if (!this.userClickLeft) {
          this.setCurrentIndex()
        }
      })
    },
    heightInit () {
      const rightItems = this.$refs.right.getElementsByClassName('s-list')
      let height = 0
      this.listHeight = []
      this.listHeight.push(height)
      for (const i in rightItems) {
        height += rightItems[i].clientHeight
        this.listHeight.push(height)
      }
    },
    scrollToTop (number, time) {
      if (!time) {
        this.$refs.right.scrollTop = number;
        return number;
      }
      const spacingTime = 10; // 设置循环的间隔时间  值越小消耗性能越高
      let spacingInex = time / spacingTime; // 计算循环的次数
      let nowTop = this.$refs.right.scrollTop; // 获取当前滚动条位置
      let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
      let scrollTimer = setInterval(() => {
        if (spacingInex > 0) {
          spacingInex--;
          this.scrollToTop(nowTop += everTop);
        } else {
          this.userClickLeft = false
          clearInterval(scrollTimer); // 清除计时器
        }
      }, spacingTime);
    },
    clickLeft (index) {
      const rightItems = this.$refs.right.getElementsByClassName('s-list')
      this.currentIndex = index
      const height = this.listHeight[index]
      // this.$refs.right.scrollTop = height
      this.userClickLeft = true
      let number = this.scrollToTop(height, 200)
    },
    setCurrentIndex () {
      if (this.userClickLeft) {
        return;
      }
      let index = 0;
      for (let i = 0; i < this.listHeight.length; i++) {
        const height = this.listHeight[i]
        const height2 = this.listHeight[i + 1]
        if (!height2 || (this.scrollY >= height && this.scrollY < height2)) {
          index = i
          break;
        }
      }
      this.currentIndex = index
    },
    getCategory () {
      this.$http.request(this.$http.pathMap.sortTree).then(res => {
        const list = res.data
        this.list = list

        this.flist = []
        this.slist = []
        this.tlist = []
        list.forEach(fitem => {
          this.flist.push(fitem)
          fitem.children.forEach(sitem => {
            this.slist.push(sitem)
            sitem.children.forEach(titem => {
              this.tlist.push(titem)
            })
          })
        })

        this.$nextTick(() => {
          this.scrollInit()
          this.heightInit()
        })
      })
    },
    navToList (fid, sid, tid, title) {
      this.$router.push({
        path: '/onlinePages/source/source',
        query: {
          fid,
          sid,
          tid,
          title
        }
      })
    }
  }
}
</script>

<style lang='scss' >
.cateContent {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #f8f8f8;
}

.cateContent {
  display: flex;
}

.left-aside {
  flex-shrink: 0;
  width: 100px;
  height: 100%;
  overflow-y: scroll;
  background-color: #fff;
}

.f-item {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  font-size: 14px;
  color: $font-color-base;
  position: relative;

  &.active {
    color: $base-color;
    background: #f8f8f8;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 18px;
      width: 4px;
      background-color: $base-color;
      border-radius: 0 4px 4px 0;
      opacity: 0.8;
    }
  }
}

.right-aside {
  flex: 1;
  overflow-y: scroll;
  padding-left: 10px;
  height: 100%;
}

.f-item-label {
  display: flex;
  align-items: center;
  height: 35px;
  font-size: 15px;
  font-weight: bold;
  color: $font-color-dark;
}

.s-item {
  display: flex;
  align-items: center;
  height: 35px;
  background-color: white;
  width: 100%;

  .s-item-left {
    flex: 1;
    height: 1px;
    background-color: #e6e6e6;
    margin: 0 10px;
  }

  .s-item-text {
    font-size: 14px;
    color: $font-color-dark;
  }

  .s-item-right {
    flex: 1;
    height: 1px;
    background-color: #e6e6e6;
    margin: 0 10px;
  }
}

.t-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  background: #fff;

  &:after {
    content: "";
    flex: 99;
    height: 0;
  }
}

.t-item {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 33%;
  font-size: 13px;
  color: #666;
  padding: 1px 0;

  img {
    width: 70px;
    height: 70px;
    margin-bottom: 5px;
  }
}
</style>
